<template>
  <div>
    <div v-if="isShowPage">
      <el-header ref="header" class="header" style="height: auto;margin-bottom: 10px">
        <el-form :inline="true" :model="searchForm" ref="searchFormRef" class="demo-form-inline">
          <div id="searchBox">
            <el-form-item label="" prop="company">
              <el-input placeholder="请输入公司名称" v-model="searchForm.company" @keydown.enter.native="handleSearchBtn"/>
            </el-form-item>
            <el-form-item label="" prop="orderid">
              <el-input placeholder="请输入订单号" v-model="searchForm.orderid" @keydown.enter.native="handleSearchBtn"/>
            </el-form-item>
          </div>
          <el-form-item>
            <el-button type="text" style="margin-left:10px" id="closeSearchBtn" @click="closeSearch">
              {{ word }}
              <i :class="showAll ? 'el-icon-arrow-up ': 'el-icon-arrow-down'"></i>
            </el-button>
            <el-button type="primary" size="small" @click="handleSearchBtn()" icon="el-icon-search">搜索
            </el-button>
            <el-button size="small" @click="handleResetBtn" icon="el-icon-refresh">重置</el-button>
          </el-form-item>
        </el-form>
      </el-header>
      <div class="custom-table search-table">
        <el-table border fit highlight-current-row class="customer-table" :data="list">
          <el-table-column type="expand">
            <template slot-scope="scope">
              <Expand :list="scope.row.childdata" :activeName="activeName" />
            </template>
          </el-table-column>
          <el-table-column label="ID" prop="id"></el-table-column>
          <el-table-column label="订单号" prop="orderid"></el-table-column>
          <el-table-column label="报价公司" prop="company"></el-table-column>
          <el-table-column label="报价人员" prop="rname"></el-table-column>
          <el-table-column label="报价价格" prop="zprice"></el-table-column>
          <el-table-column label="报价时间" prop="settime"></el-table-column>
          <el-table-column label="操作">
            <template v-slot="scope">
              <el-button type="primary" size="small" @click="generateQuotation(scope.row)">生成报价单</el-button>
              <el-popconfirm
                @confirm="generateContract(scope.row)"
                title="确认要生成合同吗？"
              >
                <el-button slot="reference" type="warning" size="small" class="quotation-contract_btn">生成合同</el-button>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination @size-change="pageSizeChange" @current-change="pageCurrentChange"
                       :current-page="selectPage.pageNum" :page-sizes="[20, 50, 100, 200]"
                       :page-size="selectPage.pageSize"
                       background
                       layout="total, sizes, prev, pager, next, jumper" :total="allNum"
                       style="margin-top: 14px;margin-bottom:14px"
        >
        </el-pagination>
      </div>
    </div>
    <el-empty description="暂无权限查看数据" v-else class="customer-category_empty" />
  </div>
</template>
<script>
import { computed, defineComponent, getCurrentInstance, onMounted, reactive, ref } from '@vue/composition-api'
import PageWrapper from '@/components/PageWrapper/index.vue'
import request from '@/utils/request'
import { Message } from 'element-ui'
import Expand from './expand.vue'
import { getToken } from '@/utils/auth'

export default defineComponent({
  components: { PageWrapper, Expand },
  props: {
    activeName: {
      type: String,
      default: ''
    }
  },
  setup(props) {
    const instance = getCurrentInstance()
    const username = instance.proxy.$store.getters.name
    const showAll = ref(false)
    const isShowPage = ref(false)
    const selectPage = reactive({
      pageNum: 1,
      pageSize: 20
    })
    const allNum = ref(1)
    const list = ref([])

    const searchFormRef = ref(null)
    const searchForm = reactive({
      company: '',
      orderid: ''
    })

    const word = computed(() => {
      if (!showAll.value) {
        return '展开'
      } else {
        return '收起'
      }
    })

    const pageSizeChange = (e) => {
      selectPage.pageSize = e
      getList()
    }
    const pageCurrentChange = (e) => {
      selectPage.pageNum = e
      getList()
    }

    const closeSearch = () => {
      showAll.value = !showAll.value
    }

    const handleSearchBtn = () => {
      selectPage.pageNum = 1
      getList()
    }

    const handleResetBtn = () => {
      searchFormRef.value.resetFields()
      getList()
    }


    const handleDelete = (scope, index) => {
      request({
        url: 'shop_type_delete.yy',
        method: 'post',
        data: { id: scope.id }
      }).then(res => {
        if (res.code == 200) deleteRow(index)
      }).catch(err => {
        Message({ message: err, type: 'error' })
      })
    }

    const deleteRow = (index) => {
      list.value.splice(index, 1)
    }
    const getList = () => {
      request({
        url: 'customer_quotation_list.yy',
        method: 'post',
        params: selectPage,
        data: {
          username: username,
          type: props.activeName,
          ...searchForm
        }
      }).then(res => {
        if (res.code == 200) {
          list.value = res.data
          allNum.value = res.total
          isShowPage.value = true
        } else if (res.code == 400) {
          isShowPage.value = false
          Message({ type: 'error', message: res.msg })
        }
      })
    }

    onMounted(() => {
      getList()
    })

    //生成合同
    const generateContract= ({orderid}) => {
      request({
        url: 'contract.yy',
        method: 'get',
        params: {orderid: orderid}
      }).then(res => {
        Message({  message: res.msg })
      })
    }

    //生成报价单
    const generateQuotation = (row) => {
      const baseUrl = process.env.VUE_APP_BASE_API
      const url = 'quotation.yy'
      const token = getToken()
      window.open(`${baseUrl}/${url}?orderid=${row.orderid}&token=${token}`)
    }

    return {
      isShowPage,
      username,
      searchFormRef,
      searchForm,
      showAll,
      allNum,
      selectPage,
      word,
      list,
      generateContract,
      generateQuotation,
      closeSearch,
      handleResetBtn,
      handleSearchBtn,
      pageSizeChange,
      pageCurrentChange,
      handleDelete,
      deleteRow
    }
  }
})
</script>
<style scoped lang="scss">

.customer-category_empty {
  height: calc(100vh - 130px);
}
.quotation-contract_btn {
  margin-left: 10px;
}

</style>

